import {FilterCategory, FilterCategoryType, FilterSets} from "@/components/filterDropdown/FilterDropdown.ts";
import {FilterDropdown} from "@/components/filterDropdown/FilterDropdown.tsx";
import {GQL_INCIDENTS_STATUS_PAGE_FILTER} from "@/lib/queries/statuspages.ts";
import {IncidentState, IncidentStateLabels} from "@/lib/types/statuspages.ts";

type IncidentsFilterProps = {
  filterSets: FilterSets<FilterCategory>;
  onFilterSetChange: (filterSet: FilterSets<FilterCategory>) => void;
};

export const IncidentsFilters = ({filterSets, onFilterSetChange}: IncidentsFilterProps) => {
  const filterFields: FilterCategory[] = [
    {
      key: "update_types",
      type: FilterCategoryType.ARRAY,
      display: "Update",
      options: Object.keys(IncidentStateLabels).map((key) => ({
        key: key,
        display: IncidentStateLabels[key as IncidentState] as string,
      })),
    },
    {
      key: "statuspages",
      type: FilterCategoryType.GQL,
      display: "Status Page",
      graphql: GQL_INCIDENTS_STATUS_PAGE_FILTER,
      sorted: true,
    },
  ];

  return <FilterDropdown categories={filterFields} appliedFilterSets={filterSets} onApply={onFilterSetChange} />;
};
